export default {"src":"/_next/static/media/chevron_white.78118d91.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};